// Define voice options for Gemini
export const GEMINI_VOICES = {
    Puck: 'Puck',
    Aoede: 'Aoede',
    Charon: 'Charon',
    Kore: 'Kore',
    Zephy: 'Zephyr',
    Orus: 'Orus',
    Leda: 'Leda',
    Fenrir: 'Fenrir',
    
};